import { Component, OnInit } from '@angular/core';
import { Widget } from 'src/app/shared/classes/Widget';
import { WidgetInjectedData } from 'src/app/shared/classes/WidgetInjectedData';
import { IconType } from 'src/app/shared/enums/IconType';
import { ModalType } from 'src/app/shared/enums/ModalType';
import { IIntegrationInput } from 'src/app/shared/interfaces/integration/IIntegrationInput';
import { IModalData } from 'src/app/shared/interfaces/modal/IModalData';
import { GcpOnboardingModalComponent } from '../../../modal-templates/account-onboarding-modals/gcp-onboarding-modal/gcp-onboarding-modal.component';
import { ButtonColorType } from './../../../../enums/ButtonColorType';
import { ButtonType } from './../../../../enums/ButtonType';

@Component({
    selector: 'app-gcp-integration',
    templateUrl: './gcp-integration.component.html',
    styleUrls: ['./gcp-integration.component.sass']
})
export class GcpIntegrationComponent implements OnInit {
    integrationInput: IIntegrationInput = null;
    widgetRef: Widget;
    constructor(widgetData: WidgetInjectedData) {
        this.widgetRef = widgetData.widgetRef;
    }

    ngOnInit(): void {
        this.setUpBasics();
    }

    setUpBasics() {
        this.integrationInput = {
            integrationName: this.widgetRef.widgetData.widgetInfo.text,
            integrationCategory: 'Cloud Integration',
            imageUrl: 'assets/cloud-icons/google-cloud-logo.png',
            buttons: [
                {
                    buttonName: 'Add',
                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,
                    hoverText: 'Add GCP Account',
                    buttonIcon: {
                        type: IconType.FONTAWSOME,
                        class: 'fas fa-plus'
                    },
                    function: (buttonRef) => {
                        //Open Modal
                        this.onIntegrate(buttonRef);
                    }
                }
            ],
            imagePadding: 8
        };
    }
    onIntegrate(buttonRef: any) {
        const modalArgs: IModalData = {
            modalIcon: {
                type: IconType.FONTAWSOME,
                class: 'fas fa-chalkboard-teacher'
            },
            modalName: 'On Board GCP',
            modalType: ModalType.MIDDLE,
            sourceId: this.widgetRef.uniqueIdentity,
            extraStepContainerClass: 'remove-form-space',
            modalSteps: [
                {
                    stepName: 'Step 1',
                    resetModal: true,
                    stepData: {
                        componentToLoad: GcpOnboardingModalComponent,
                        payload: {
                            data: {
                                widgetInfo: this.widgetRef.widgetData.widgetInfo
                            }
                        }
                    }
                }
            ],
            modalWidthVw: 60,
            modalHeightPx: 435
        };
        this.widgetRef.modalService.openModal(modalArgs);
    }
}
